import { useEffect } from 'react';
import { isBrowser } from '@web3/utils';

export const useGoogleScript = () => {
  useEffect(() => {
    if (!isBrowser) {
      return;
    }
    const scriptId = 'web3-gg-sct';
    if (document.getElementById(scriptId)) {
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-PMHBL76');`;
    script.id = scriptId;
    document.body.appendChild(script);
  }, []);
};
